import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { format } from "date-fns"
import Loader from "@/components/layout/loader"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import OptionsDropdownMenu from "@/components/ux/options.dropdown-menu"
import {
  BankAccount,
  getAccountNumber,
  useBankAccounts,
  useBankAccountsActions,
} from "@/api/bank-accounts"
import { toast } from "sonner"
import { ConfirmDialog } from "@/components/ux/confirm.dialog"
import { AlertDialog, AlertDialogTrigger } from "@/components/ui/alert-dialog"

export default function BankAccountsTable() {
  const { bankAccounts, hasMore, size, setSize, isLoading } =
    useBankAccounts()
  const { remove } = useBankAccountsActions()

    const onRemove = async (bankAccount: BankAccount) => {
    await remove(bankAccount.id)
    toast.success("BankAccount removed")
  }

  if (!bankAccounts) {
    return <Loader message="Loading Bank Accounts..." />
  }

  return (
    <Table>
      <TableHeader>
        <TableRow className="rounded-t-md">
          <TableHead className="pl-6">Bank Name</TableHead>
          <TableHead className="pl-6">Account Number</TableHead>
          <TableHead>Created On</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {bankAccounts.map((bankAccount) => (
          <TableRow key={bankAccount.id}>
            <TableCell className="pl-6">{bankAccount.bankName}</TableCell>
            <TableCell>{getAccountNumber(bankAccount)}</TableCell>
            <TableCell>
              {format(new Date(bankAccount.createdAt), "MMM do, yyyy")}
            </TableCell>
            <TableCell>
              <AlertDialog>
                <ConfirmDialog
                  onConfirm={() => onRemove(bankAccount)}
                  title="Remove Bank Account"
                  description={`Are you sure you want to remove ${bankAccount.bankName}?`}
                />
                <OptionsDropdownMenu>
                  <AlertDialogTrigger asChild>
                    <DropdownMenuItem data-testid="delete">
                      Remove
                    </DropdownMenuItem>
                  </AlertDialogTrigger>
                </OptionsDropdownMenu>
              </AlertDialog>
            </TableCell>
          </TableRow>
        ))}
        {bankAccounts.length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="text-center text-gray-300">
              No Bank Accounts found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
      {hasMore && (
        <TableFooter>
          <TableRow>
            <TableCell colSpan={4}>
              <button
                data-testid="load-more"
                onClick={() => setSize(size + 1)}
                className="flex flex-col w-full items-center bg-white p-3 text-center"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Load more..."}
              </button>
            </TableCell>
          </TableRow>
        </TableFooter>
      )}
    </Table>
  )
}
